import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetDashboardExportReportInterface {
  startDate: string;
  endDate: string;
}

export const useGetDashboardDownloadView = () => {
  const mutate = useMutation(({ startDate, endDate }: GetDashboardExportReportInterface) => {
    return get(`/external-api/download_views_bydaterange/${startDate}/${endDate}`, {
      responseType: 'blob',
    });
  });

  return mutate;
};

export default useGetDashboardDownloadView;
